import { Toaster as Sonner } from "sonner";

const Toaster = () => {
  return (
    <Sonner
      position="top-right"
      richColors
      closeButton
      expand={true}
      visibleToasts={5}
    />
  );
};

export { Toaster };
